// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2Tm9F","loaderOuter":"PageOverlayLoader_loaderOuter__XRCLt"};